<ng-container *ngrxLet="latitude$ as latitude">
    <span *ngrxLet="longitude$ as longitude">{{ latitude }} {{ longitude }}</span>
</ng-container>
